import invariant from 'tiny-invariant';
import { AbstractConnector } from '@web3-react/abstract-connector';
import { BigNumber } from '@ethersproject/bignumber';
import { resolveProperties } from '@ethersproject/properties';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var isHIDSupported = () => {
  try {
    return 'hid' in window.navigator;
  } catch (error) {
    return false;
  }
};
var hasEIP1559 = tx => {
  return tx.type === 2 || tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
};
var toNumber = value => {
  return value == null ? undefined : BigNumber.from(value).toNumber();
};
var convertToUnsigned = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator(function* (tx) {
    var resolvedTx = yield resolveProperties(tx);
    var {
      chainId,
      data,
      gasLimit,
      gas,
      gasPrice,
      value,
      to
    } = resolvedTx;
    var nonce = toNumber(resolvedTx.nonce);
    var type = toNumber(resolvedTx.type); // Allowed transaction keys for Legacy and EIP-155 Transactions

    var baseTx = {
      gasLimit: gasLimit || gas,
      type: type != null ? type : 2,
      chainId,
      gasPrice,
      nonce,
      value,
      data,
      to
    }; // EIP-2930

    if (tx.accessList != null) {
      baseTx.accessList = tx.accessList;
    } // EIP-1559


    if (hasEIP1559(tx)) {
      baseTx.maxFeePerGas = tx.maxFeePerGas;
      baseTx.maxPriorityFeePerGas = tx.maxPriorityFeePerGas;
      baseTx.type = 2;
    }

    return baseTx;
  });

  return function convertToUnsigned(_x) {
    return _ref.apply(this, arguments);
  };
}();
var checkError = error => {
  if (error.statusText === 'INS_NOT_SUPPORTED') {
    error.message = 'Device is not supported. Make sure the Ethereum app is open on the device.';
  }

  if (error.statusText === 'UNKNOWN_ERROR') {
    error.message = 'Unknown error. Make sure the device is connected and the Ethereum app is open on the device.';
  }

  if (error.statusText === 'CONDITIONS_OF_USE_NOT_SATISFIED') {
    error.message = 'User rejected the request';
  }

  throw error;
};

class LedgerHQConnector extends AbstractConnector {
  constructor(_ref) {
    var {
      chainId,
      url
    } = _ref;
    super({
      supportedChainIds: [chainId]
    });
    this.chainId = chainId;
    this.url = url;
    this.handleDisconnect = this.handleDisconnect.bind(this);
  }

  handleDisconnect() {
    this.emitDeactivate();
  }

  isSupported() {
    return isHIDSupported();
  }

  getProviderInstance() {
    var _this = this;

    return _asyncToGenerator(function* () {
      var {
        LedgerHQProvider
      } = yield import('./provider-fa788480.js');
      var Provider = new LedgerHQProvider(_this.url, _this.chainId);
      return Provider;
    })();
  }

  activate() {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      try {
        if (!_this2.provider) {
          _this2.provider = yield _this2.getProviderInstance();
        }

        _this2.provider.on('disconnect', _this2.handleDisconnect);

        var account = yield _this2.provider.enable();
        return {
          provider: _this2.provider,
          account
        };
      } catch (error) {
        return checkError(error);
      }
    })();
  }

  getProvider() {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      return _this3.provider;
    })();
  }

  getChainId() {
    var _this4 = this;

    return _asyncToGenerator(function* () {
      return _this4.chainId;
    })();
  }

  getAccount() {
    var _this5 = this;

    return _asyncToGenerator(function* () {
      !_this5.provider ? process.env.NODE_ENV !== "production" ? invariant(false, 'Provider is not defined') : invariant(false) : void 0;
      return _this5.provider.getAddress();
    })();
  }

  deactivate() {
    !this.provider ? process.env.NODE_ENV !== "production" ? invariant(false, 'Provider is not defined') : invariant(false) : void 0;
    this.provider.removeListener('disconnect', this.handleDisconnect);
  }

}

export { LedgerHQConnector as L, _asyncToGenerator as _, _extends as a, convertToUnsigned as b, checkError as c, toNumber as t };
//# sourceMappingURL=index-26341a95.js.map
